import "../../../assets/scss/template-card-style.scss";
import { useTranslation } from "react-i18next";
import { updateTemplateSelectionInfo } from "../../features/selection/selectionSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { TemplateCardInterface } from "../../utility/interface/template-card";
import { Button, Modal, Select } from "antd";
import { useState } from "react";
import { RentSummaryModal } from "../RentSummaryModal";

export const TemplateCard = (props: TemplateCardInterface) => {
  const { t } = useTranslation();
  const {
    template_id,
    template_name,
    description,
    label,
    icon_url = "default",
    start_script,
    fakeData,
    vendor,
    versions = [],
    enabled = true,
  } = props;
  const dispatch = useAppDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (targetTemplateId: number) => {
    dispatch(updateTemplateSelectionInfo(targetTemplateId));
    setIsModalOpen(true);
  };

  // Determine if single version and disabled
  const singleDisabled = versions.length === 1 && versions[0].enabled === false;

  // Apply gray-out style if the entire template is disabled
  const cardClass = `template-card ${!enabled ? "disabled" : ""}`;

  return (
    <>
      <div className={`block ${!enabled ? "disabled" : ""}`}>
        <section className={fakeData ? "template-card fake" : cardClass}>
          <div className="template-image-container">
            <div
              className="template-card-image"
              style={{
                backgroundImage: icon_url?.includes("anythingllm")
                  ? `url(/images/templates/anythingllm.png)`
                  : `url(/images/templates/${icon_url}.png)`,
              }}
            >
              <div className="template-card-icon">
                <img
                  src={`/images/templates/icons/${icon_url}-icon.svg`}
                  style={
                    icon_url?.includes("dalle") ? { height: "54px" } : undefined
                  }
                  alt={`${template_name} icon`}
                />
              </div>
            </div>
          </div>

          <div className="template-card-specs">
            <div className="template-card-header">
              <h3>{template_name}</h3>
              <span className="tag">{label}</span>
            </div>
            <p className="description">{description}</p>

            {/* RENT LOGIC */}
            <div className="template-card-action">
              {versions.length <= 1 && (
                <Button
                  disabled={fakeData || singleDisabled || !enabled}
                  type="primary"
                  onClick={() => openModal(template_id)}
                >
                  {t("Rent")}
                </Button>
              )}

              {versions.length > 1 && (
                <Select
                  className="rent-select"
                  value={t("Select Versions")}
                  onChange={(value) => openModal(Number(value))}
                  placement="topLeft"
                  disabled={!enabled}
                >
                  {versions.map((item: any) => (
                    <Select.Option
                      key={item.id}
                      value={item.id}
                      disabled={!item.enabled}
                    >
                      {item.image_version}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </div>
          </div>
        </section>

        <Modal
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          width={520}
          centered
          destroyOnClose
        >
          <RentSummaryModal closeModal={() => setIsModalOpen(false)} />
        </Modal>
      </div>
    </>
  );
};
